// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1JM32","col":"Table_col__-JQUf","fulfillmentStatus":"Table_fulfillmentStatus__2rW6-","emailCol":"Table_emailCol__2zRzY"};